import { render } from "./EditStylist.vue?vue&type=template&id=354060eb&scoped=true"
import script from "./EditStylist.vue?vue&type=script&lang=js"
export * from "./EditStylist.vue?vue&type=script&lang=js"

import "./EditStylist.vue?vue&type=style&index=0&id=354060eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354060eb"]])

export default __exports__